import { RouteObject } from 'react-router';

import { InventoryList } from './InventoryList';
import { SalesList } from './SalesList';

export const REPORTS_ROUTES: RouteObject[] = [
    {
        path: 'sales',
        Component: SalesList,
    },
    {
        path: 'inventory',
        Component: InventoryList,
    },
];
